import { createMultiStyleConfigHelpers as n, defineStyle as e } from "@chakra-ui/react";
import { ThemeColorVariable as o, ThemeSpaceVariable as r, ThemeFontVariable as a } from "../../theme-types.js";
import { ThemeFontSizeToken as t } from "../theme-tokens.js";
import { tableAnatomy as l } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: d, defineMultiStyleConfig: i } = n(l.keys), b = e({
  position: "relative",
  fontFamily: a.Body,
  fontSize: t.Small,
  th: {
    padding: "0px",
    position: "relative",
    fontSize: t.Small,
    height: "40px",
    color: o.OnBackgroundSubdued,
    fontWeight: 400,
    textTransform: "none",
    div: {
      _hover: {
        backgroundColor: o.BackgroundDisabled
      }
    }
  },
  td: {
    color: o.OnBackground,
    padding: `0px 0px 0px ${r.Small}`,
    borderRight: `1px solid ${o.OnBackgroundBorder}`,
    height: "40px",
    gap: r.XSmall,
    _last: {
      borderRight: "none"
    }
  },
  tr: {
    borderColor: o.OnBackgroundBorder
  }
}), s = e({
  cursor: "pointer",
  backgroundColor: o.Surface,
  div: {
    span: {
      color: o.OnBackgroundSubdued,
      fontWeight: 400
    }
  }
}), c = e({
  color: o.OnBackground
}), p = e({
  borderTop: "1px solid",
  _first: {
    borderTop: "none"
  },
  _last: {
    borderBottom: "1px solid",
    borderColor: o.OnBackgroundBorder
  }
}), g = e({
  tr: {
    zIndex: 10,
    backgroundColor: o.OnBackgroundSubdued
  }
}), u = d({
  table: b,
  tfoot: c,
  th: s,
  tr: p,
  thead: g
}), k = i({
  baseStyle: u
});
export {
  k as tableConfig
};
